import { ForwardedRef, forwardRef, useRef } from 'react';
import classNames from 'classnames';

import { DawnArrowDown } from '@xemplo/icons';
import { V2, V2Types } from '@xemplo/popover';
import { List } from '@xemplo/stateful-list';
import { SvgStroke } from '@xemplo/style-constants';

import { useDropdownMetadata } from '../hooks/use-dropdown-meta';
import { TextDropdownProps } from '../types/text-dropdown.types';

import * as S from './text-dropdown.styles';

export const TextDropdown = forwardRef(
  (props: TextDropdownProps, ref?: ForwardedRef<HTMLInputElement>) => {
    const { trailingIcon, searchable } = props;
    const popoverRef = useRef<V2Types.PopoverRef>(null);
    const { rootProps, displayInputProps, hiddenInputProps, listProps } =
      useDropdownMetadata({ ...props, popoverRef });

    return (
      <V2.Popover.Root {...rootProps} ref={popoverRef}>
        <V2.Popover.Trigger usePropRefKey="wrapperRef">
          {({ open }) => (
            <S.CustomXemploInput
              {...displayInputProps}
              ref={ref}
              className={classNames({ open, 'not-searchable': !searchable })}
              trailingIcon={
                trailingIcon ?? (
                  <DawnArrowDown
                    strokeWidth={SvgStroke.Light}
                    className={classNames('trailing', { open })}
                  />
                )
              }
            />
          )}
        </V2.Popover.Trigger>
        <V2.Popover.Popup>
          <List.SingleSelect {...listProps} />
        </V2.Popover.Popup>
        <input {...hiddenInputProps} />
      </V2.Popover.Root>
    );
  },
);
